import React from 'react';
import { TextField, Autocomplete, CircularProgress } from '@mui/material';
import { Person } from '@mui/icons-material';
import { GraphUser } from '../../../../../utils/MsGraphApiCall';
import { UserSearchOption } from './UserSearchOption';

interface UserSearchAutocompleteProps {
  label: string;
  placeholder?: string;
  value: GraphUser | null;
  users: GraphUser[];
  isLoading: boolean;
  searchQuery: string;
  onInputChange: (value: string) => void;
  onSelect: (_event: React.SyntheticEvent, user: GraphUser | null) => void;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

export const UserSearchAutocomplete: React.FC<UserSearchAutocompleteProps> = ({
  label,
  placeholder,
  value,
  users,
  isLoading,
  searchQuery,
  onInputChange,
  onSelect,
  required = false,
  error = false,
  helperText,
}) => (
  <Autocomplete
    size="small"
    options={users}
    loading={isLoading}
    value={value}
    onChange={onSelect}
    onInputChange={(_event, newInputValue) => onInputChange(newInputValue)}
    getOptionLabel={(option) => option.displayName || option.mail || ''}
    isOptionEqualToValue={(option, val) => option.id === val.id}
    noOptionsText={searchQuery.length < 2 ? 'Type to search users...' : 'No users found'}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        placeholder={placeholder}
        required={required}
        error={error}
        helperText={helperText}
        InputProps={{
          ...params.InputProps,
          startAdornment: <Person sx={{ mr: 1, color: 'action.active' }} />,
          endAdornment: (
            <>
              {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
    renderOption={(props, option) => (
      <UserSearchOption user={option} {...props} />
    )}
  />
);
